import { log } from '../../services/utils';

import { controller } from '../../contexts/DashboardContext';

import { noraApiRequest } from './';

export const getSimpleVisual = async (
	reportType,
	parm = 0,
	dateStart = new Date( new Date().setDate( new Date().getDate() - 60 ) ).toISOString(), // 60 days
	dateEnd = new Date().toISOString()
) => {
	log( '* get simple visual' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: '/visual/simple',
		params: {
			reportType,
			parm,
			dateStart,
			dateEnd
		},
		signal: controller.signal
	} );

	return response.data;
};

export const getStackedVisual = async (
	reportType,
	parm = 0,
	dateStart = new Date( new Date().setDate( new Date().getDate() - 60 ) ).toISOString(), // 60 days
	dateEnd = new Date().toISOString()
) => {
	log( '* get stacked visual' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: '/visual/stacked',
		params: {
			reportType,
			parm,
			dateStart,
			dateEnd
		},
		signal: controller.signal
	} );

	return response.data;
};
